/* eslint-disable */
/* eslint disabled since it's detecting many false positives */

import { enqueueSnackbar } from "notistack";
import {
  AppendixStructuresResponse,
  PredefinedSectionDocument,
} from "../Models/appendixStructure";
import { AnnexDocument } from "./useAnnexActions";
import { useEffect } from "react";
import { DocumentsResponse } from "../Models/company";
import { useTranslation } from "react-i18next";

export const useAnnexCleanup = ({
  selectedPredefinedSection,
  predefinedSection,
  removeDocument,
  removePredefinedDocument,
  predefinedAnnex,
  predefinedData,
  isLoadingPredefinedData,
  annex,
  documents,
}: {
  selectedPredefinedSection: number | null;
  predefinedSection: PredefinedSectionDocument[];
  removeDocument: (id: number) => void;
  removePredefinedDocument: (id: number) => void;
  predefinedAnnex: Record<number, AnnexDocument[]>;
  predefinedData?: AppendixStructuresResponse;
  isLoadingPredefinedData?: boolean;
  annex?: AnnexDocument[];
  documents?: DocumentsResponse;
}) => {
  const { t } = useTranslation("snack");

  useEffect(() => {
    if (
      !selectedPredefinedSection ||
      !predefinedAnnex ||
      !predefinedData ||
      isLoadingPredefinedData
    )
      return;

    const annexPredefined = predefinedAnnex[selectedPredefinedSection];

    if (!annexPredefined) return;

    const flatAnnex = annexPredefined.flatMap((doc) => [
      doc,
      ...(doc.subsections || []),
    ]);
    const flatPredefinedSections = predefinedSection.flatMap((section) => [
      section,
      ...(section.subsections || []),
    ]);

    const sectionIds = flatPredefinedSections.map((section) => section.id!);

    const unavailableDocs = flatAnnex.filter(
      (doc) => !sectionIds.includes(doc.placeholder_id || "")
    );

    if (unavailableDocs.length > 0) {
      unavailableDocs.forEach((doc) => {
        removePredefinedDocument(doc.id!);
      });

      enqueueSnackbar(t("annex.predefinedSectionsRemoved"), {
        variant: "info",
      });
    }
  }, [predefinedSection, removePredefinedDocument]);

  useEffect(() => {
    if (!documents || !annex) return;

    const documentIds = documents?.documents.map((doc) => doc.id) || [];
    const annexDocs = annex.flatMap((doc) => [doc, ...(doc.subsections || [])]);

    const unavailableDocs = annexDocs.filter(
      (doc) =>
        !documentIds.includes(doc.id!) &&
        doc.type !== "empty_section" &&
        doc.type !== "title"
    );

    unavailableDocs.forEach((doc) => {
      removeDocument(doc.id!);
    });

    if (unavailableDocs.length > 0) {
      enqueueSnackbar(t("annex.documentsRemovedFromAnnex"), {
        variant: "info",
      });
    }

    if (!selectedPredefinedSection) return;

    const selectedPredefinedAnnex = predefinedAnnex[selectedPredefinedSection];
    const predefinedAnnexDocs = selectedPredefinedAnnex?.flatMap((doc) => [
      doc,
      ...(doc.subsections || []),
    ]);

    const unavailablePredefinedDocs = predefinedAnnexDocs?.filter(
      (doc) => !documentIds.includes(doc.id)
    );

    unavailablePredefinedDocs?.forEach((doc) => {
      removePredefinedDocument(doc.id!);
    });

    if (unavailablePredefinedDocs?.length > 0) {
      enqueueSnackbar(t("annex.documentsRemovedFromPredefinedAnnex"), {
        variant: "info",
      });
    }
  }, [documents, selectedPredefinedSection, removeDocument]);
};
